import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTiktokShopConfigurationQuery = createQueryHook(
  CreatorIntegrationsApiClient.getTiktokPartnerConfiguration,
  {
    queryKey: ['tiktokShopConfiguration'],
  },
)
